import React, { useState, useEffect } from 'react';
import firebase from '../firebase';
import Card from '../Models/Card';
import Chat from '../Components/Chat';
import 'firebase/firestore';
import 'firebase/auth';
import './FiresaleView.css';

import { useDocumentData } from 'react-firebase-hooks/firestore';
import {useListVals} from 'react-firebase-hooks/database';

const auth = firebase.auth();
const firestore = firebase.firestore();

//TODO:

//1. ONCE CARD IS AT THE LAST INDEX -> START OVER? END?
//2. ARROW?

function FiresaleView() {

    

    const tempCards: any = [];

    const [snapshots, loading, error] = useListVals(firebase.database().ref('cards/'),{transform: (snap) => {
        var tempCard = new Card(snap.description, snap.firm, snap.price, snap.url, snap.id);
        tempCards.push(tempCard);
    }});

    const maxIndex = snapshots!.length -1;



    const [index] = useDocumentData(firestore.collection('currentIndex').doc('index'));
    const [ind, setInd] = useState(0);
 

    const usersRef = firestore.collection('users');
    const [users] = useDocumentData(usersRef.doc(auth.currentUser?.uid));
   

    useEffect(() => {

        if (index){
            setInd(index.i);
        }

        //TODO: figure out timer - for now we will have a pass button

        /*if(users?.admin){
            console.log('admin')

            if(index!.i < maxIndex){
                var timer = setTimeout(() =>{
    
                    var tempI = index?.i + 1;
                    firestore.collection('currentIndex').doc('index').update({
                        i: tempI,
                    });
                }, 7000);
                //clearInterval(timer);


            }else{
                console.log('we should restart or display something')
            }

        }
    
    
        firestore.collection('currentIndex').doc('index').onSnapshot((doc) => {
            var i = doc.data()!.i;
            setInd(i);

        });*/

        firestore.collection('currentIndex').doc('index').onSnapshot((doc) => {
            var i = doc.data()!.i;
            setInd(i);
        });


    }, [users, index, maxIndex]);

    const pass = (e: any) =>{
        e.preventDefault();
      //  setInd(ind + 1);
      if (index!.i < maxIndex){
        var tempI = index?.i + 1;
        firestore.collection('currentIndex').doc('index').update({
            i: tempI,
        });
        console.log(ind);
      }

    }

    const claim = (e: any) =>{
        e.preventDefault();
        
        if (index!.i < maxIndex){
        var card = {
            price: tempCards[ind].price,
            url: tempCards[ind].url
        };

        var tempI = index?.i + 1;
        firestore.collection('currentIndex').doc('index').update({
            i: tempI,
        });



        usersRef.doc(auth.currentUser!.uid).update({
            cards: firebase.firestore.FieldValue.arrayUnion(card)
        });
    }

    
    }

    const total = users?.cards.reduce((sum: any, currentValue: any) => sum = sum + currentValue.price, 0);
    var pic: any;
    pic = '';

    if(index){
        pic = index.i < maxIndex ? <img style={{maxHeight: '60vh', maxWidth: '80vw'}}  alt='' src={tempCards[ind]?.url} /> : <img height="100vh" src="http://austintebbs.com/thatsallfolks.gif"/>;
    }

    return (


        
        <div className='container' >
            <div className='row '>
                <div className='col-lg-6'>
                        <div style={{ marginLeft: '2vw', fontSize: 'xx-large'}}>{'$' + tempCards[ind]?.price || ''} 
                            <span style={{marginRight: '2vw'}}></span>
                            {tempCards[ind]?.description || ''}
                        </div>

                    <div style={{ display: 'inline-flex', }}>
                        {pic}
                        
                       
                    </div>
                    <div className='row '>
                <div >
                    <button style={{marginLeft: '1.4vw', marginRight: '1.4vw'}} className='btn-lg btn-light' >Offer</button>
                    <button style={{marginLeft: '1.4vw', marginRight: '1.4vw'}} onClick={pass} className='btn-lg btn-secondary' >Pass</button>
                    <button style={{marginLeft: '1.4vw', marginRight: '1.4vw'}} className='btn-lg btn-success' onClick={claim} >Sold</button>
                </div>


            </div>

                   
                </div>
                <div className='col-lg-3'>
                <span style={{fontSize: 'xx-large'}}>Total: ${total}</span>
                    <div style={{display: 'flex', flexDirection: 'column', overflowY: 'scroll', marginTop: '2vh',backgroundColor: 'white', borderStyle: 'solid', height: '45vh'}}>
                        {users?.cards && users?.cards.map((card: any, id: number) => <div key={id}> <img alt='' style={{maxHeight: '30vh', maxWidth: '30vw'}} src={card.url} /> <span style={{fontSize: 'x-large'}}>${card.price}</span> </div>)}
                    </div>
                    
                </div>
            </div>
 
            <div style={{}}className='row d-none d-lg-block'>
                <div className='col-6'>
                <Chat />

                </div>
            </div>
        </div>
    )
}

export default FiresaleView;